import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import NavbarLink from './navbar-link';

const NavbarLinkSection = ({ sectionText, handleMenuToggle, isMobile, children, alignRight }) => {

  return (
    <li
      data-toggle={isMobile ? 'collapse' : null}
      onClick={(e) => handleMenuToggle(e)}
      data-target="#navsitemenu"
    >
      <span className="mega-menu-title" style={{textAlign: alignRight ? 'right' : ''}}>{sectionText}</span>
      <ul className="sub-menu">
        {children}
      </ul>
    </li>
  );
};

export default NavbarLinkSection;
